export default __webpack_public_path__ + "static/media/no_encuentra.fb7938d4.png";